import FuseNavigation from '@fuse/core/FuseNavigation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import clsx from 'clsx';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectNavigation } from 'app/store/fuse/navigationSlice';
import { navbarCloseMobile } from '../../store/fuse/navbarSlice';
import PropTypes from 'prop-types';

function Navigation({ className, layout = 'vertical', dense, active }) {
	const navigation = useSelector(selectNavigation);
	const theme = useTheme();
	const mdDown = useMediaQuery(theme.breakpoints.down('md'));
	const dispatch = useDispatch();

	function handleItemClick(item) {
		mdDown && dispatch(navbarCloseMobile());
	}

	return (
		<FuseNavigation
			className={clsx('navigation', className)}
			navigation={navigation}
			layout={layout}
			dense={dense}
			active={active}
			onItemClick={handleItemClick}
		/>
	);
}

Navigation.propTypes = {
  className: PropTypes.string,
  layout: PropTypes.any,
  dense: PropTypes.bool,
  active: PropTypes.bool,
};

export default memo(Navigation);
